var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgU(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 36,
    viewBox: "0 0 28 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_88)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.0781 0.875V23.3516C27.0781 27.0859 25.9062 30.0391 23.5625 32.2109C21.2344 34.3828 18.0469 35.4688 14 35.4688C10.0156 35.4688 6.85156 34.4141 4.50781 32.3047C2.16406 30.1953 0.96875 27.2969 0.921875 23.6094V0.875H7.95312V23.3984C7.95312 25.6328 8.48438 27.2656 9.54688 28.2969C10.625 29.3125 12.1094 29.8203 14 29.8203C17.9531 29.8203 19.9609 27.7422 20.0234 23.5859V0.875H27.0781Z",
    fill: "url(#paint0_linear_6_88)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_88",
    x1: 14,
    y1: 0.875,
    x2: 14,
    y2: 35.4688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3477DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A9AE3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_88"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgU);
export default __webpack_public_path__ + "static/media/U.8818a943704964aabd53d6a3b1380ce2.svg";
export { ForwardRef as ReactComponent };